import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import FeedAlgosTable from './FeedAlgosTable';
import FeedAlgoCard from './FeedAlgoCard';
import FeedAlgoTest from './FeedAlgoTest';
import { useGlobal } from '../contexts/GlobalContext';

function FeedAlgoExplorerColumn({ refreshKey, onEditFeed, onDeleteFeed, onDuplicateFeed }) {
  const { mergeCurrentContext } = useGlobal();
  const [selectedFeed, setSelectedFeed] = useState(null);

  useEffect(() => {
    mergeCurrentContext({
      selectedFeed: selectedFeed ? { algo_id: selectedFeed.algo_id, algorithm: selectedFeed.algorithm } : undefined,
    });
    return () => mergeCurrentContext({ selectedFeed: undefined });
  }, [selectedFeed, mergeCurrentContext]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Box sx={{ p: 1.5, borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight="medium">
            Feed algos
          </Typography>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2 }}>
          <FeedAlgosTable
            selectedFeed={selectedFeed}
            onSelectFeed={setSelectedFeed}
            refreshKey={refreshKey}
          />
        </Box>
      </Box>
      
      <FeedAlgoCard
        feed={selectedFeed}
        onEdit={onEditFeed}
        onDelete={async (feed) => {
          await onDeleteFeed?.(feed);
          setSelectedFeed(null);
        }}
        onDuplicate={onDuplicateFeed}
      />

      {selectedFeed && (
        <FeedAlgoTest
          title={`Test feed algo #${selectedFeed.algo_id}`}
          algorithm={selectedFeed.algorithm ?? ''}
          sdkVersion={selectedFeed.sdk_version ?? 'V1'}
          feedType={selectedFeed.feed_type ?? 'algorithm'}
          feedInputs={selectedFeed.feed_inputs ?? 'user_id'}
          signature={selectedFeed.signature ?? ''}
          validateInProgress={false}
        />
      )}

    </Box>
  );
}

export default FeedAlgoExplorerColumn;
